import React, {useState} from 'react'
import './BottomNav.scss'
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {setActivePage} from "../../Actions";
import {assetUrl} from "../../serviceApi";
import Login from "../../pages/Login/Login";

const homeActive = assetUrl+"images/appbar-homeActive1.svg";
const home = assetUrl+"images/appbar-Home1.svg";
const portfolio = assetUrl+"images/appbar-Portfolio1.svg";
const portfolioActive = assetUrl+"images/appbar-PortfolioActive1.svg";
const leaderboard = assetUrl+"images/icon_leaderboard_dark_new.svg";
const leaderboardActive = assetUrl+'images/icon_leaderboard_light_new1.svg'
const menu = assetUrl+"images/appbar-more1.svg";
const activeMenu = assetUrl+'images/icon_more_dots_white.svg'

const BottomNav = (props) => {
    const [login_modal,setLoginModal] = useState(false);
    const checkUserLoggedIn = () => {
        if(props.logged_in === false){
            openLoginModal();
        } else  {
            props.setActivePage("menu");
            props.history.push("/wallet");
        }
    }
    const openLoginModal = () => {
        setLoginModal(true);
    }
    const closeLoginModal = () => {
        setLoginModal(false);
    }
    const completeLogin = () => {
        closeLoginModal();
        window.location.reload();
    }

    const btnav = "btnav-"
    return (
        <div>

            <div className={btnav + "appbar d-flex align-items-end justify-content-between my-1 px-4 py-2"}>
                <div
                    className={`${btnav}appbar-iconwrapper${props.active_page === "home" ? "-active" : ""} text-center`}
                    onClick={() => {
                        return (props.history.push("/home") , props.setActivePage("home"))
                    }}
                >
                    <img src={props.active_page === "home" ? homeActive : home} alt={'home'}
                         className={`${btnav}appbar-icon ${props.active_page === "home" ? " active-icon" : ""}`}/>
                    <p className={btnav + "appbar-name "+ (props.active_page === "home"?"active-tab":"in-active-tab")}>Home</p>
                </div>

                <div
                    className={`${btnav}appbar-iconwrapper${props.active_page === "portfolio" ? "-active" : "in-active-tab"} text-center`}
                    onClick={() =>{
                        return (props.history.push("/portfolio") , props.setActivePage("portfolio"))
                    }}
                >
                    <img src={props.active_page === "portfolio" ? portfolioActive : portfolio} alt={'home'}
                         className={`${btnav}appbar-icon ${props.active_page === "portfolio" ? " active-icon" : ""}`}/>
                    <p className={btnav + "appbar-name "+ (props.active_page === "portfolio"?"active-tab":"in-active-tab")}>Portfolio</p>
                </div>


                <div
                    className={`${btnav}appbar-iconwrapper${props.active_page === "chart"? "-active" : ""} text-center`}
                    onClick={() => {
                        return (props.history.push("/profile") , props.setActivePage("chart"))
                    }}
                >
                    <img src={(props.active_page === "chart") ? leaderboardActive : leaderboard}
                         alt={'home'}
                         className={`${btnav}appbar-icon ${(props.active_page === "chart") ? " active-icon" : ""}`}/>
                    <p className={btnav + "appbar-name  "+ (props.active_page === "chart"?"active-tab":"in-active-tab")}>Leaderboard</p>

                </div>


                <div className={`${btnav}appbar-iconwrapper${props.active_page === "menu" ? "-active" : ""} text-center`}
                     onClick={checkUserLoggedIn}

                    // onClick={() => {
                    //     return (props.history.push("/wallet") , props.setActivePage("menu"))
                    // }}
                >
                    <img src={props.active_page === "menu" ? activeMenu : menu} alt={'home'}
                         className={`${btnav}appbar-icon ${props.active_page === "menu" ? " active-icon" : ""}`}/>
                    <p className={btnav + "appbar-name " + (props.active_page === "menu"?"active-tab":"in-active-tab")}>More</p>

                </div>
            </div>
            <Login isOpen={login_modal}
                   closeModal={closeLoginModal}
                   completeLogin={completeLogin}
            />

        </div>
    )
}

const mapStateToProps = state => ({
    active_page: state.UserReducer.active_page,
    logged_in: state.UserReducer.logged_in
})

const mapDispatchToProps = dispatch => ({
    setActivePage: data => dispatch(setActivePage(data))
})

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(BottomNav);
